import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { pixelPageView } from "@/lib/metaPixel";

/**
 * En una SPA cambiar de ruta no recarga la pagina, asi que el PageView del init
 * seria el unico de toda la sesion y Meta veria una web de una sola pagina.
 * Se salta el primer render porque ese PageView ya lo dispara initMetaPixel().
 */
export default function PixelPageView() {
    const { pathname } = useLocation();
    const first = useRef(true);

    useEffect(() => {
        if (first.current) {
            first.current = false;
            return;
        }
        pixelPageView();
    }, [pathname]);

    return null;
}
